import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

import IdentityProvidersConstants from 'workspaces/launcher/constants/IdentityProvidersConstants';
import IdentityProviders from 'workspaces/launcher/data/IdentityProviders';

const Content: {
  item: IdentityProviders,
  isSaving: boolean
} = {
  item: new IdentityProviders(),
  isSaving: false
};

class State extends Immutable.Record(Content) {
}

class IdentityProvidersStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  getItem (): IdentityProviders {
    return this.getState().item;
  }

  override reduce (state: State, action: ActionType): State {
    switch (action.actionType) {
      case IdentityProvidersConstants.SAVE:
      case IdentityProvidersConstants.SAVE_SUCCESS:
      case IdentityProvidersConstants.GET_SUCCESS: {
        return state.set('item', action.item);
      }
    }
    return state;
  }
}

export default new IdentityProvidersStore();
